export default {
	"ability": {
		"warning": "early warning",
		"checkTime": "advance confirm order time (hours)",
		"pickupTime": "delivery late warning time (hours)",
		"backTime": "receipt time (days)",
		"schedulingTime": "advance scheduling time (hours)",
		"deliveryTime": "delivery late warning (hours)",
		"continuous": "continuous",
		"tips1": "sub-temperature warning will notify its immediate superior",
		"gpsOutPush": "gps return frequency (min)",
		"customerExceptionTime": "customer feedback timeliness (days)",
		"transportTips": "shipping order access",
		"lightRate": "volume/weight ratio",
		"orderMerge": "whether the skus with the same document details are automatically merged",
		"singleTrial": "confirm",
		"manualOrImportOrder": "manually created and imported orders can be closed",
		"interfaceOrder": "if orders from other system with interface are allowed to close",
		"optionOrderStatus": "the business point that allows to revoke the confirmation and close the operation is",
		"notScheduling": "not scheduled",
		"notPickUp": "not picked up",
		"orderMustProject": "Surcharge/Discount are required to place an order",
		"pushOrderAutoMatch": "automatically match sites while receiving orders with interface",
		"billingTips": "billing",
		"billingPoint": "shipping orders generate billing business points at the latest",
		"none": "no control",
		"dispatched": "schedule",
		"routeBusinessBillingPoint": "a billing service point will be generated at the latest in the dispatch order",
		"billingLogDebug": "detailed log of billing record",
		"planTips": "plan",
		"routeTempComposeRule": "create a dispatch list with temperature intersection",
		"confirmGrouporder": "automatically generate dispatch orders from online documents",
		"ms": "multitask + single task",
		"m": "multitasking",
		"routeTimeComposeRule": "there is an overlap in the time to create a dispatch order",
		"mixFullLoadRatio": "full load rate lower limit",
		"maxFullLoadRatio": "full load rate upper limit",
		"subsequentProcessing": "subsequent automatic operation of the vehicle order during order review",
		"n": "no need to handle",
		"c": "generate dispatch list",
		"cc": "generate dispatch list and confirm",
		"autoPlanSenderAddress": "aggregate cables for delivery points within the fence",
		"trialStrategy": "route planning trial strategy",
		"scheduling": "scheduled on the same date",
		"pScheduleRouteMustProject": "scheduling must require products/items",
		"pDispatchVehicleReminder": "reminders for scheduling repeated vehicle",
		"departure": "same departure date",
		"pDispatchingOfflineCarrierCapacity": "schedule offline carrier capacity information",
		"mb": "must",
		"dmb": "no need",
		"pUnscheduledDocumentSwitch": "allows carriers to view unscheduled documents",
		"perform": "execution",
		"pContinueShortMessageOnOnlineuser": "continue to send text messages after sending in-site messages",
		"pGpsMonitorNode": "tracking vehicle gps",
		"pTerminalShowExpFeedbackCsh": "the mobile terminal displays abnormal contact numbers",
		"pTerminalShowCsh": "mobile phone display customer service phone number",
		"pTerminalShowCshTel": "consumer hotline",
		"pAppointment": "reserve",
		"prebookPickupCapacityRequired": "capacity information must be required when making a pickup appointment",
		"prebookDeliveryCapacityRequired": "capacity information must be required when making a delivery appointment",
		"mustPrebook": "documents that can be reserved with other systems must be reserved",
		"pMustDeliverByOtherSystem": "documents reserved with other systems must be shipped by other systems",
		"pPushCapacityToUp": "capacity is fully synchronized to upstream",
		"pNeedMsgForReserve": "need to send a message when booking",
		"sendPickTips3": "Pickup & Delivery",
		"pPickupInforNeededTakePhoto": "need to upload photos of pickup when confirm pickup",
		"pDeliveryInforNeededTakePhoto": "need to upload POD when confirm delivery",
		"pNeedConfirmDelivery": "the downstream delivery needs to be confirmed",
		"pInterfaceSyncTransDataOp": "synchronous shipping interface - data synchronization method -  [check] synchronize data and update pickup,  [uncheck] synchronize data only",
		"pDeliverySignAddressExceptionReason": "out-of-scope delivery must fill in reason",
		"pH5PickupDataEditableOnApiSync": "after synchronizing the shipping data from upstrem system, support the driver to change the pickup quantity",
		"pH5WorkingCollectMode1": "orders with detailed items according to",
		"pH5WorkingCollectMode2": "abnormal pickup & delivery",
		"wechatAndWeb": "mini program/public account",
		"pScanPickupUploadPic": "public account pick-up information collection must be with photos",
		"pScanDeliveryUploadPic": "public account delivery information collection must be with photos",
		"pScanPickupDeliveryConfirm": "the data collected by the public account needs to be confirmed",
		"pH5PickupCapacityEditable": "the vehicle information can be changed when the public account picks up the goods",
		"pScanPickupedVehicleTemperature": "the car temperature must be tested for the public account to pick up the goods",
		"pScanPickupedGoodsTemperature": "the temperature of the goods must be tested for the public account to pick up the goods",
		"pScanReceivedGoodsTemperature": "the public account must test the temperature of the goods when receiving the goods",
		"pBetweenReceivedAndSignedRate": "the fastest collection and sign-off interval",
		"pPickupWaitDedaultTime": "shipping default free waiting time (minutes)",
		"pTransferPrintMaxNumber": "label printing limit times",
		"pAutoDeliveryBuffer": "automatic delivery completion buffer time (hours)",
		"monitortips": "monitor",
		"pDetentionGpsTimes": "default location range size",
		"pVehicleStayTimeMax": "abnormal delivery",
		"abilityTipsCarrier": "A quote for a carrier must exist to access the document",
		"upStreamOrder": "Upstream consignor pushes orders",
		"restingTime": "Resting Time",
		"minWorkingHourAlert": "minimum working hour alert (minutes)",
		"maxWorkingHourAlert": "maximum working hour alert (minutes)",
		"alertForOverWorkHour": "alert when over working hour (minutes)",
		"minRestingTimeDuration": "minimum resting time duration (minutes)",
		"maxRestingTimeDuration": "maximum resting time duration (minutes)",
		"alertBeforeEndingMaxRestingTime": "alert before ending maximum resting time (minutes)",
		"distanceOfNearbyRestStop": "distance of nearby rest Stop (kilometres)",
		"invalidMinWorkingHourAlert": "Invalid minimum working hour alert",
		"invalidMaxWorkingHourAlert": "Invalid maximum working hour alert",
		"invalidAlertForOverWorkHour": "Invalid alert when over working hour",
		"invalidMinRestingTimeDuration": "Invalid minimum resting time duration",
		"invalidMaxRestingTimeDuration": "Invalid maximum resting time duration",
		"invalidAlertBeforeEndingMaxRestingTime": "Invalid alert before ending maximum resting time",
		"invalidDistanceOfNearbyRestStop": "Invalid distance of nearby rest Stop",
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/ability/ability.js